const images = {
  viFlag: require('./images/viFlag.jpg'),
  enFlag: require('./images/enFlag.jpg'),
  logo: require('./images/logo.png'),
  qrCode: require('./images/qr-code.jpg'),

  screenshot: {
    vi: {
      bac: require('./images/bacVi.png'),
      biologicalAge: require('./images/biologicalAgeVi.png'),
      bmi: require('./images/bmiVi.png'),
      bmr: require('./images/bmrVi.png'),
      calculateMeal: require('./images/calculateMealVi.png'),
      caloBurn: require('./images/caloBurnVi.png'),
      fatRatio: require('./images/fatRatioVi.png'),
      nutritionStatistic: require('./images/nutritionStatisticVi.png'),
      nutritionStatistic2: require('./images/nutritionStatistic2Vi.png'),
      nutritionTable: require('./images/nutritionTableVi.png'),
      ovulationDay: require('./images/ovulationDayVi.png'),
      skelie: require('./images/skelieVi.png'),
      waterRequire: require('./images/waterRequireVi.png'),
      weightPregnancy: require('./images/weightPregnancyVi.png'),
      whr: require('./images/whrVi.png'),
      detailFood: require('./images/detailFoodVi.png'),
      checkingHealth: require('./images/checkingHealthVi.png'),
      checkingSymptom: require('./images/checkingSymptomVi.png'),
    },
    en: {
      bac: require('./images/bacEn.png'),
      biologicalAge: require('./images/biologicalAgeEn.png'),
      bmi: require('./images/bmiEn.png'),
      bmr: require('./images/bmrEn.png'),
      calculateMeal: require('./images/calculateMealEn.png'),
      caloBurn: require('./images/caloBurnEn.png'),
      fatRatio: require('./images/fatRatioEn.png'),
      nutritionStatistic: require('./images/nutritionStatisticEn.png'),
      nutritionStatistic2: require('./images/nutritionStatistic2En.png'),
      nutritionTable: require('./images/nutritionTableEn.png'),
      ovulationDay: require('./images/ovulationDayEn.png'),
      skelie: require('./images/skelieEn.png'),
      waterRequire: require('./images/waterRequireEn.png'),
      weightPregnancy: require('./images/weightPregnancyEn.png'),
      whr: require('./images/whrEn.png'),
      detailFood: require('./images/detailFoodEn.png'),
      checkingHealth: require('./images/checkingHealthEn.png'),
      checkingSymptom: require('./images/checkingSymptomEn.png'),
    }
  }
}

export default images
